import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { FinalitiesService } from 'src/app/shared/services/finalities.service';

@Component({
  selector: 'app-finality-selection',
  templateUrl: './finality-selection.component.html',
  styleUrls: ['./finality-selection.component.scss'],
})
export class FinalitySelectionComponent implements OnInit, OnDestroy {
  @Output('finalitySelected') finalitySelected: EventEmitter<FinalitiesDto> =
    new EventEmitter(null);
  @Input('rType') rType = null;
  @Input() warrenGlobalOnly?: boolean;

  finalities?: FinalitiesDto[];
  finalities$?: Subscription;
  personType: string;

  isMobile = false;
  get individualId() {
    return +this.authService.getIndividualId();
  }

  constructor(
    private readonly finalitiesService: FinalitiesService,
    private readonly authService: AuthenticationService
  ) {
    this.personType = this.individualId ? 'pf' : 'pj';
  }

  ngOnDestroy(): void {
    this.finalities$?.unsubscribe();
  }

  select(finality: FinalitiesDto) {
    this.finalitySelected.emit(finality);
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820;

    this.finalities$ = this.finalitiesService
      .getByPersonType(this.personType, this.rType)
      .subscribe({
        next: (result) => {
          if (this.warrenGlobalOnly) {
            this.finalities = result.data.filter(
              (f) => f.id === 22 || f.id === 30
            );
          } else {
            this.finalities = result.data;
          }
        },
      });
  }
}
